import { DocumentFormSetSearchRequestQuery, DocumentSearchRequestQuery } from '@lio/api-types';
import { quoteQueryKey } from '../quotes/keys';

export const documentQueryKey = {
  get: ['document'] as const,
  getWithParams: (params: any) => [...documentQueryKey.get, params] as const,
  search: ['documents'] as const,
  searchWithParams: (params: DocumentSearchRequestQuery) => [...documentQueryKey.search, params] as const,
  searchDocumentFormSet: (quoteId: string, params: DocumentFormSetSearchRequestQuery) =>
    [quoteQueryKey.get(quoteId), 'document-form-set', params] as const,
};
